// import { fetchBaseQuery } from "@reduxjs/toolkit/dist/query";
import GetProxy from "../GetProxy";
import { api } from "./baseApiSetup";
const proxy = GetProxy();
const BASE_URL = `${proxy}/api/v1`;
const MODULE_BASE_URL = `${proxy}/cmdb/api/v1`;
const ASK_AI_URL = `${proxy}/askAI/api/v1`;
const CMDB_SETTINGS_URL = `${proxy}/api/v1`;

export const configurationApi = api.injectEndpoints({
  endpoints: (build) => ({
    createTools: build.mutation({
      query: ({ payload, loguserName }) => ({
        url: `${MODULE_BASE_URL}/tools/saveAndUpdateToolsDetails/${loguserName}`,
        method: "POST",
        body: payload,
      }),
    }),
    changeToolsStatus: build.mutation({
      query: ({ id, status, userName }) => ({
        url: `${MODULE_BASE_URL}/tools/toolsStatusUpdate/${id}/${status}/${userName}`,
        method: "PUT",
      }),
    }),
    getConfigToolsList: build.query({
      query: ({ page = 0, limit = 10 }) => {
        return `${MODULE_BASE_URL}/tools/listByItemsPerPage/${page}/${limit}`;
      },
    }),
    getToolDetailsById: build.query({
      query: ({ id, timeStamp }) =>
        `${MODULE_BASE_URL}/tools/${id}?_=${timeStamp}`,
    }),
    TestConnection: build.mutation({
      query: (postBody = {}) => ({
        url: `${MODULE_BASE_URL}/tools/connection/check`,
        method: "POST",
        body: postBody,
      }),
    }),
    TestConnectionTenable: build.mutation({
      query: (postBody = {}) => ({
        url: `${MODULE_BASE_URL}/tools/checkConnectionForTenable`,
        method: "POST",
        body: postBody,
      }),
    }),
    deleteTools: build.mutation({
      query: ({ id, loguserName }) => ({
        url: `${MODULE_BASE_URL}/tools/deleteToolsDetails/${id}/${loguserName}`,
        method: "DELETE",
      }),
    }),
    getToolsListCount: build.query({
      query: () => `${MODULE_BASE_URL}/tools/count`,
    }),
    getToolsPlugin: build.query({
      query: (timestamp) => `${MODULE_BASE_URL}/toolsPlugin?_=${timestamp}`,
    }),
    getToolsName: build.query({
      query: ({ type, timestamp }) =>
        `${MODULE_BASE_URL}/toolsPlugin/${type}?_=${timestamp}`,
    }),
    //Tools Configuration Roles
    getAccessDetailsById: build.query({
      query: (toolId) =>
        `${MODULE_BASE_URL}/devops/tools/role/config/role/config/${toolId}`,
    }),
    saveConfig: build.mutation({
      query: ({ payload, userName }) => ({
        url: `${MODULE_BASE_URL}/devops/tools/role/config/${userName}`,
        method: "POST",
        body: payload,
      }),
    }),
    //Groups
    getGroupsList: build.query({
      query: ({ page = 0, limit = 10 }) =>
        `${MODULE_BASE_URL}/groups/listByItemsPerPage/${page}/${limit}`,
    }),
    getGroupsListCount: build.query({
      query: () => `${MODULE_BASE_URL}/groups/count`,
    }),
    checkDuplicateGroup: build.query({
      query: (groupId) => `${MODULE_BASE_URL}/groups/${groupId}`,
    }),
    createGroup: build.mutation({
      query: ({ payload, userName }) => ({
        url: `${MODULE_BASE_URL}/groups/${userName}`,
        method: "POST",
        body: payload,
      }),
    }),
    deleteGroup: build.mutation({
      query: ({ groupId, userName }) => ({
        url: `${MODULE_BASE_URL}/groups/${groupId}/${userName}`,
        method: "DELETE",
      }),
    }),
    // Logging Configuration
    getLoggingConfiguration: build.query({
      query: () =>
        `${MODULE_BASE_URL}/logger/level/dtop.tech?_=${new Date().getTime()}`,
    }),
    postLoggingConfig: build.mutation({
      query: ({ payload, userName }) => ({
        url: `${CMDB_SETTINGS_URL}/logger/levelChange/${userName}`,
        method: "POST",
        body: payload,
      }),
    }),
    //User Management
    getUsersCount: build.query({
      query: () => `${MODULE_BASE_URL}/licence/user/count`,
    }),
    getUsersList: build.query({
      query: ({ page, limit }) =>
        `${MODULE_BASE_URL}/licence/user/list/${page}/${limit}`,
    }),
    changeUserStatus: build.mutation({
      query: ({ payload, userName }) => ({
        url: `${MODULE_BASE_URL}/licenceUser/status/${userName}`,
        method: "PUT",
        body: payload,
      }),
    }),
    getUsersDetails: build.query({
      query: () => `${MODULE_BASE_URL}/directory/get/members/details`,
    }),
    getSecurityDetails: build.query({
      query: () => `${MODULE_BASE_URL}/aws/get/members/details`,
    }),
    getUserDetail: build.mutation({
      query: ({ payload }) => ({
        url: `${MODULE_BASE_URL}/licenceUser/getDataByUsernameAndRoles`,
        method: "POST",
        body: payload,
      }),
    }),
    checkUserExist: build.query({
      query: (id) => `${MODULE_BASE_URL}/licence/user/validation/${id}`,
    }),
    manageUser: build.mutation({
      query: ({ payload, userName }) => ({
        url: `${MODULE_BASE_URL}/licenceUser/saveLicenseUserDetails/${userName}`,
        method: "POST",
        body: payload,
      }),
    }),
    getOnboardedTools: build.query({
      query: (id) => `${MODULE_BASE_URL}/licence/user/onboarded/tools/${id}`,
    }),
    deleteUser: build.mutation({
      query: ({ payload }) => ({
        url: `${MODULE_BASE_URL}/licenceUser/deleteLicencedUser`,
        method: "DELETE",
        body: payload,
      }),
    }),
    //License Configuration
    getLicense: build.query({
      query: () => `${CMDB_SETTINGS_URL}/license`,
    }),
    manageLicense: build.mutation({
      query: ({ licenseStr, userName }) => ({
        url: `${BASE_URL}/license/${userName}`,
        method: "POST",
        body: licenseStr,
      }),
      transformResponse: (response, meta) => {
        return { data: response, status: meta?.response?.status };
      },
    }),
    getLicenseConfigList: build.mutation({
      query: () => ({
        url: `${MODULE_BASE_URL}/serverConfigInfo/list/operatingSystem`,
        method: "GET",
      }),
    }),
    // SMTP Configuration
    getSmtpConfig: build.query({
      query: () => `${CMDB_SETTINGS_URL}/smtpConfig/getSmtpConfig`,
      method: "GET",
    }),
    verifyTestmail: build.mutation({
      query: (postBody = {}) => ({
        url: `${BASE_URL}/smtpConfig/verification`,
        method: "POST",
        body: postBody,
      }),
    }),
    UrlConfiguration: build.mutation({
      query: (payload) => ({
        url: `${BASE_URL}/licence/valid/url`,
        method: "POST",
        body: payload,
      }),
    }),
    manageSmtpConfiguration: build.mutation({
      query: ({ payload, userName }) => ({
        url: `${CMDB_SETTINGS_URL}/smtpConfig/${userName}`,
        method: "POST",
        body: payload,
      }),
    }),
    //LDAP Configuratiom
    getDirectory: build.query({
      query: () => `${CMDB_SETTINGS_URL}/directory`,
    }),
    testLdapConnection: build.mutation({
      query: (postBody = {}) => ({
        url: `${CMDB_SETTINGS_URL}/directory/check/connection`,
        method: "POST",
        body: postBody,
      }),
    }),
    updateLdapConfig: build.mutation({
      query: ({ payload, userName }) => ({
        url: `${CMDB_SETTINGS_URL}/directory/${userName}`,
        method: "POST",
        body: payload,
      }),
    }),

    // Business info page

    getBusinessInfoSave: build.mutation({
      query: ({ userName, payload }) => ({
        url: `${MODULE_BASE_URL}/businessInfoConfig/saveOrUpdate/${userName}`,
        method: "POST",
        body: payload,
      }),
    }),
    getBusinessInfoList: build.mutation({
      query: ({ page, limit }) => ({
        url: `${MODULE_BASE_URL}/businessInfoConfig/list/BusinessInfoConfig/${page}/${limit}`,
        method: "GET",
      }),
    }),
    getBusinessdelete: build.mutation({
      query: ({ id, userName }) => ({
        url: `${MODULE_BASE_URL}/businessInfoConfig/delete/${id}/${userName}`,
        method: "DELETE",
      }),
    }),

    getBusinessEdit: build.mutation({
      query: (id) => ({
        url: `${MODULE_BASE_URL}/businessInfoConfig/${id}`,
        method: "GET",
      }),
    }),

    getBusinessCount: build.mutation({
      query: () => ({
        url: `${MODULE_BASE_URL}/businessInfoConfig/count`,
        method: "GET",
      }),
    }),

    getBusinessInfoData: build.mutation({
      query: ({ cmdbId }) => ({
        url: `${MODULE_BASE_URL}/businessInfoConfig/getBusinessInfoConfigUsingCmdbId/${cmdbId}`,
        method: "POST",
      }),
    }),

    //Home API
    getApplication: build.mutation({
      query: (userName) => ({
        // url: `${MODULE_BASE_URL}/Landing/getApplications/${userName}`,
        url: `${proxy}/cmdb/api/v1/Landing/getApplications/${userName}`,
        method: "GET",
      }),
    }),
    getApplicationInfo: build.mutation({
      query: (appCode) => ({
        // url: `${MODULE_BASE_URL}/Landing/getApplicationDetails/${appCode}`,
        url: `${proxy}/cmdb/api/v1/Landing/getApplicationDetails/${appCode}`,
        method: "GET",
      }),
    }),
    getBusinessInfo: build.mutation({
      query: (appCode) => ({
        url: `${proxy}/cmdb/api/v1/Landing/getBusinessInfo/${appCode}`,
        method: "GET",
      }),
    }),
    getServerForApplication: build.mutation({
      query: (appCode) => ({
        url: `${proxy}/cmdb/api/v1/Landing/getServerForApplication/${appCode}`,
        method: "GET",
      }),
    }),
    getAccountIdForApplication: build.mutation({
      query: (appCode) => ({
        url: `${proxy}/cmdb/api/v1/Landing/getAccountIdForApplication/${appCode}`,
        method: "GET",
      }),
    }),
    getUserForApplication: build.mutation({
      query: (appCode) => ({
        url: `${proxy}/cmdb/api/v1/Landing/getUserForApplication/${appCode}`,
        method: "GET",
      }),
    }),

    //Home COMPLIANCE SCORE

    getPreOfVM: build.mutation({
      query: (postBody = {}) => ({
        // url: `${MODULE_BASE_URL}/Landing/getComplianceScoreOfVulnerabilityManagement`,
        url: `${proxy}/report/api/v1/vm/getVulnerabilityScore`,
        method: "POST",
        body: postBody,
      }),
    }),
    getPreOfSHF: build.mutation({
      query: (postBody = {}) => ({
        url: `${proxy}/report/api/v1/securityHub/getComplianceScoreOfSecurityHubFindings`,
        method: "POST",
        body: postBody,
      }),
    }),
    // getPreOfTRMG: build.mutation({
    //   query: (postBody = {}) => ({
    //     url: `${MODULE_BASE_URL}/Landing/getComplianceScoreOfTRMG`,
    //     method: "POST",
    //     body: postBody,
    //   }),
    // }),
    // getPreOfCircular09: build.mutation({
    //   query: (postBody = {}) => ({
    //     url: `${MODULE_BASE_URL}/Landing/getComplianceScoreOfCircular09`,
    //     method: "POST",
    //     body: postBody,
    //   }),
    // }),
    getPreOfRMITCompliance: build.mutation({
      query: (postBody = {}) => ({
        url: `${proxy}/report/api/v1/conformancePack/getComplianceScoreForRegulatoryCompliance`,
        method: "POST",
        body: postBody,
      }),
    }),
    getTopAssignee: build.mutation({
      query: (payload) => ({
        url: `${MODULE_BASE_URL}/Landing/homePage/topAssignee`,
        method: "POST",
        body: payload,
      }),
    }),
    getTopDevelopers: build.mutation({
      query: (payload) => ({
        url: `${MODULE_BASE_URL}/Landing/projectChampionsForHomePage`,
        method: "POST",
        body: payload,
      }),
    }),

    //Home User Access Review
    getUserAccessReviewerDetails: build.mutation({
      query: (appCode) => ({
        url: `${MODULE_BASE_URL}/UserAccessRest/getUserAccessReviewerDataWithDueDetails/${appCode}`,
        method: "GET",
      }),
    }),
    getAppUserDetails: build.mutation({
      query: (appCode) => ({
        url: `${MODULE_BASE_URL}/UserAccessRest/userAccessReviewerNamelistData/${appCode}`,
        method: "GET",
      }),
    }),
    getAppUserPublicCount: build.mutation({
      query: ({ appCode, payload }) => ({
        url: `${MODULE_BASE_URL}/UserAccessRest/getCloudAccountDetailsCount/${appCode}`,
        method: "POST",
        body: payload,
      }),
    }),
    getAppUserPrivateListCount: build.mutation({
      query: ({ appCode, payload }) => ({
        url: `${MODULE_BASE_URL}/UserAccessRest/getUserAccessReviewerData/${appCode}`,
        method: "POST",
        body: payload,
      }),
    }),

    getUserPrivateCloud: build.mutation({
      query: ({ appCode, pageNo, pageLimit, payload }) => ({
        url: `${MODULE_BASE_URL}/UserAccessRest/getUserAccessReviewerData/${appCode}/${pageNo}/${pageLimit}`,
        method: "POST",
        body: payload,
      }),
    }),

    getUserPublicCloud: build.mutation({
      query: ({ appCode, pageNo, pageLimit, payload }) => ({
        url: `${MODULE_BASE_URL}/UserAccessRest/getCloudAccountDetails/${appCode}/${pageNo}/${pageLimit}`,
        method: "POST",
        body: payload,
      }),
    }),
    getPrivateConfirm: build.mutation({
      query: (payload) => ({
        url: `${MODULE_BASE_URL}/UserAccessRest/retainOrRevokeStatusUpdate`,
        method: "POST",
        body: payload,
      }),
    }),
    getPublicConfirm: build.mutation({
      query: (payload) => ({
        url: `${MODULE_BASE_URL}/UserAccessRest/retainOrRevokeStatusUpdateCloud`,
        method: "POST",
        body: payload,
      }),
    }),
    getAppUserPendingCount: build.mutation({
      query: (appCode) => ({
        url: `${MODULE_BASE_URL}/UserAccessRest/userAccessReviewPendingTotalCountByStatus/${appCode}`,
        method: "GET",
      }),
    }),
    //ChatGpt API
    getChatgptQueryRequest: build.mutation({
      query: ({ payload }) => ({
        url: `${ASK_AI_URL}/askAI/getASKAIResponse`,
        method: "POST",
        body: payload,
      }),
    }),
    //userInfo - CMDB

    // getUserInfoCmdb: build.mutation({
    //   query: () => ({
    //     url: `${MODULE_BASE_URL}/LDAPDashboard/UserInfoForCmdb`,
    //     method: "GET",
    //   }),
    // }),
    getUserInfoSave: build.mutation({
      query: (payload) => ({
        url: `${MODULE_BASE_URL}/LDAPDashboard/saveLDAPUserDetails`,
        method: "POST",
        body: payload,
      }),
    }),
    getUserInfoDelete: build.mutation({
      query: ({ id }) => ({
        url: `${MODULE_BASE_URL}/LDAPDashboard/deleteUserDetails/${id}`,
        method: "DELETE",
      }),
    }),
    //licenseConfign - CMDB
    getLicenseList: build.mutation({
      query: ({ page, limit }) => ({
        url: `${MODULE_BASE_URL}/licenceConfigForServerRest/list/${page}/${limit}`,
        method: "GET",
      }),
    }),
    getLicenseListOs: build.mutation({
      query: () => ({
        url: `${MODULE_BASE_URL}/serverConfigInfo/list/operatingSystem`,
        method: "GET",
      }),
    }),
    getLicenseSave: build.mutation({
      query: (payload) => ({
        url: `${BASE_URL}/licenceConfigForServerRest/saveTheLicenceServerConfig`,
        method: "POST",
        body: payload,
      }),
    }),
    getLicenseDelete: build.mutation({
      query: ({ id }) => ({
        url: `${MODULE_BASE_URL}/licenceConfigForServerRest/delete/${id}`,
        method: "DELETE",
      }),
    }),
    getServerApplicationList: build.mutation({
      query: () => ({
        url: `${MODULE_BASE_URL}/Landing/getServerForApplication/CODE8`,
        method: "GET",
      }),
    }),
    getCloudAccountsList: build.mutation({
      query: () => ({
        url: `${MODULE_BASE_URL}/Landing/getAccountIdForApplication/CODE8`,
        method: "GET",
      }),
    }),
    // new provision - CMDB
    getProvisionList: build.mutation({
      query: () => ({
        url: `${MODULE_BASE_URL}/InfraProvision/getInfraProvisionList`,
        method: "GET",
      }),
    }),
    // getProvisionId: build.mutation({
    //   query: (id) => ({
    //     url: `${MODULE_BASE_URL}/InfraProvision/getInfraProvisionById/${id}`,
    //     method: "GET",
    //   })
    // }),
    getProvisionSave: build.mutation({
      query: (payload) => ({
        url: `${MODULE_BASE_URL}/InfraProvision/saveInfraProvision`,
        method: "POST",
        body: payload,
      }),
    }),
    // cloudAccounts - CMDB
    getCloudList: build.mutation({
      query: () => ({
        url: `${MODULE_BASE_URL}/CSPForAws/getCspAccountList`,
        method: "GET",
      }),
    }),
    getCloudTrigger: build.mutation({
      query: () => ({
        url: `${MODULE_BASE_URL}/awsIam/IAMdetails`,
        method: "GET",
      }),
    }),
    getCloudAccountSave: build.mutation({
      query: (payload) => ({
        url: `${MODULE_BASE_URL}/awsIam/saveMasterCloudAccounts`,
        method: "POST",
        body: payload,
      }),
    }),
    getCloudDelete: build.mutation({
      query: (payload) => ({
        url: `${MODULE_BASE_URL}/awsIam/deleteMasterCloudAccount`,
        method: "DELETE",
        body: payload,
      }),
    }),

    getsaveAsset: build.mutation({
      query: ({ payload, userName }) => ({
        url: `${MODULE_BASE_URL}/assetConfiguration/saveOrUpdateAssetConfiguration/${userName}`,
        method: "POST",
        body: payload,
      }),
    }),
  }),
  overrideExisting: true,
});
